import { useEffect } from "react";
import Routes from "./router/routes";
import { useAuth0 } from "@auth0/auth0-react";
import "../src/styles/styles.css";
import LoadingScreen from "./components/loadingScreen";

function LoginRedirect() {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
  useEffect(() => {
    if (!isAuthenticated && !isLoading) loginWithRedirect();
  }, [loginWithRedirect, isAuthenticated, isLoading]);
  return <></>;
}

function App() {
  const { isLoading, isAuthenticated, error, user, loginWithRedirect, logout } = useAuth0();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <LoginRedirect />;
  }

  console.log("user is", user);

  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
